import { Component, Input, OnChanges, OnDestroy, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { Subject, Subscription } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { ConfirmDialogComponent } from 'src/app/shared/modules/alerts/confirm-dialog/confirm-dialog.component';
import { MyHomeService } from '../../service/my-home.service';
import { MyHomeState } from '../../state/my-home.state';
import { CreateMortgageDialogComponent } from '../create-mortgage-dialog/create-mortgage-dialog.component';

@Component({
  selector: 'app-mortgage-group',
  templateUrl: './mortgage-group.component.html',
  styleUrls: ['./mortgage-group.component.scss'],
})
export class MortgageGroupComponent implements OnInit, OnChanges, OnDestroy {
  mortgageArray = [];
  activeTabIndex = 0;
  totalMortgageList = [];
  selectedMortgageList = [];
  consolidatedMortgage = {
    principal: 0,
    interest: 0,
    term: 0,
    startDate: null,
  };
  applyNowInprogress;
  compoundLoanStats: any = null;
  onDestroyNotifier$ = new Subject();
  originalMortgageComputedLoan: any;
  term: any;

  // Subscription
  parentSub$: Subscription = new Subscription();
  isEquityAnalysis: boolean = false;
  finalMortgageList: any[];

  constructor(private dialog: MatDialog, private myHomeState: MyHomeState, private myHomeService: MyHomeService, private router: Router,) { }
  @Input() mortgageList;

  ngOnInit() {
    const path = this.router.url.split('?')[0];
    if (path?.includes('equity-analysis')) {
      this.isEquityAnalysis = true;
    }
    let selectedMortgageIndexSub$ = this.myHomeState.selectedMortgageIndex$
      .pipe(takeUntil(this.onDestroyNotifier$))
      .subscribe((tabIndex) => {
        this.activeTabIndex = tabIndex;
      });
    let activeHomeSub$ = this.myHomeState.activeHome$.pipe(takeUntil(this.onDestroyNotifier$)).subscribe((res) => {
      if (res && res.mortgageList)
        this.compoundLoanStats = JSON.parse(JSON.stringify(this.myHomeService.getCompoundLoanStats(res.mortgageList)));
    });

    this.parentSub$.add(selectedMortgageIndexSub$);
    this.parentSub$.add(activeHomeSub$);
  }

  ngOnChanges() {
    this.mortgageArray = this.mortgageList;
    if (this.mortgageArray && this.mortgageArray.length) {
      this.consolidatedMortgage = {
        principal: 0,
        interest: 0,
        term: 0,
        startDate: null,
      };
      this.totalMortgageList = this.mortgageArray.map((mortgage) => {
        mortgage.checked = true;
        return mortgage;
      });
      this.selectedMortgageList = this.totalMortgageList;
      this.setConsolidatedMortgage(this.selectedMortgageList);
    }
  }

  ngOnDestroy() {
    this.parentSub$.unsubscribe();
    this.onDestroyNotifier$.next();
    this.onDestroyNotifier$.complete();
  }

  openMortgagePopup(data?) {
    this.dialog.open(CreateMortgageDialogComponent, {
      width: '385px',
      disableClose: true,
      data: {
        type: data && data.type ? data.type : 'addMortgage',
        title: data && data.title ? data.title : 'Add Mortgage',
        message: data && data.message ? data.message : 'Add missing mortgage to current property!',
        principal: data && data.principal ? data.principal : null,
        interest: data && data.interest ? data.interest : '',
        term: data && data.term ? data.term : '',
        startDate: data && data.startDate ? data.startDate : '',
        id: data && data.id ? data.id : null,
        index: data && data.index != null ? data.index : null
      },
    });
  }

  tabChange(event) {
    this.activeTabIndex = event.index;
    this.myHomeState.selectedMortgageIndexValue = event.index;
  }

  updateSelectedMortgageList(checked, mortgage) {
    if (checked) {
      this.selectedMortgageList.push(mortgage);
    } else {
      this.selectedMortgageList = this.selectedMortgageList.filter((selectedMortgage) => {
        if (selectedMortgage.id != mortgage.id) {
          return selectedMortgage;
        }
      });
    }
    this.setConsolidatedMortgage(this.selectedMortgageList);
  }

  getActiveIndex() {
    return this.myHomeState.selectedMortgageIndex$;
  }

  setConsolidatedMortgage(selectedMortgageList) {
    let consolidatedValue = {
      principal: 0,
      interest: 0,
      term: 0,
      startDate: null,
      createType: 'consolidated',
    };
    if (selectedMortgageList && selectedMortgageList.length) {
      let totalInterest = 0;
      let maxTerm = selectedMortgageList[0].term;
      let oldestDate = selectedMortgageList[0].startDate;
      selectedMortgageList.forEach((mortgage) => {
        consolidatedValue.principal += mortgage.principal;
        totalInterest += mortgage.interest;
        if (mortgage.term > maxTerm) {
          maxTerm = mortgage.term;
        }
        oldestDate = this.findOldestDate(oldestDate, mortgage.startDate);
      });
      if (totalInterest) {
        consolidatedValue.interest = Math.round((totalInterest / selectedMortgageList.length) * 100) / 100;
      }
      consolidatedValue.term = maxTerm;
      consolidatedValue.startDate = oldestDate;
    }
    this.consolidatedMortgage = consolidatedValue;
  }

  findOldestDate(date1, date2) {
    let diff = new Date(date1).getTime() - new Date(date2).getTime();
    if (diff == 0 || diff < 0) {
      return date1;
    } else if (diff > 0) {
      return date2;
    }
  }

  applyNow() {
    this.myHomeService
      .contactLender({ homeId: this.myHomeState.activeHomeValue.id })
      .pipe(takeUntil(this.onDestroyNotifier$))
      .subscribe((res: any) => {
        this.applyNowInprogress = res.isLoading;
      });
  }

  editMortgage(mortgage, i?) {
    let data = {
      type: 'editMortgage',
      title: 'Edit Mortgage',
      message: 'Update selected mortgage of current property!',
      principal: mortgage.principal,
      interest: mortgage.interest,
      term: Math.round(mortgage.term / 12),
      startDate: mortgage.startDate,
      id: mortgage.id,
      index: i
    };
    this.openMortgagePopup(data);

  }

  deleteMortgage(id, i?) {
    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      width: '385px',
      disableClose: true,
      hasBackdrop: true,
      data: {
        type: 'deleteMortgageUnderMyProperty',
        message: 'The selected mortgage will be deleted from current property',
        title: 'Do you want to delete?',
        proceedAction: (status, callBack) => {
          if (status && !this.isEquityAnalysis) {
            this.myHomeService
              .deleteMortgage(id)
              .pipe(takeUntil(this.onDestroyNotifier$))
              .subscribe((res: any) => {
                callBack({ status: true });
                dialogRef.close();
              });
          } else if (status && this.isEquityAnalysis) {
            this.myHomeState.mortgageList$.pipe(takeUntil(this.onDestroyNotifier$)).subscribe((data) => {
              this.finalMortgageList = this.removeAtIndex(i, data)
            });
            this.myHomeState.mortgageListValue = this.finalMortgageList
            dialogRef.close();
          }

          else {
            return false;
          }
        },
        proceedCancelAction: () => {
          dialogRef.close();
        },
      },
    });
  }

  openSaveOnMortgageArticleSheet() {
    this.myHomeState.isArticleSheetOpenedValue = "saveOnMortgage";
  }
  removeAtIndex(index: number, data) {
    const result = [];
    for (let i = 0; i < data.length; i++) {
      if (i !== index) {
        result.push(data[i]);
      }
    }
    return result;
  }
}
